// Step 1
// Get the Membership ProductStep
import Product from "../product-component/product";
import TagManager from "react-gtm-module";
import Helper from "../../common/helper";
import StepsIndicator from "../steps-indicator";
import NextButton from "../../components/UI/next-button";
import Layout from "../layout";
import ErrorBoundary from "../errors/ErrorBoundary";

export default function ProductStep({
  benefitsTranslations,
  currentStep,
  goNextStep,
  languages,
  locationDataCurrency,
  locationData,
  products,
  selectMembership,
  isProductLoaded,
  error,
  stepNo,
  couponObj,
  isUserLogged,
  businessCategories,

  isDisabled,
  part,
  full,
  isProcessing,
}) {
  if (parseInt(currentStep) !== parseInt(stepNo)) {
    return null;
  }
  //GTM initialize

  if (
    window.dataLayer.filter((a) => a.pageCategory === "Join now").length < 1
  ) {
    TagManager.dataLayer(Helper.gtmPageView("", "Join now", "logged-out", ""));
  }
  if (window.dataLayer.filter((a) => a.checkoutStep === 1).length < 1) {
    TagManager.dataLayer(
      Helper.gtmFunnelPage(
        locationData.currency,
        1,
        "",
        window.location.pathname,
        "",
        []
      )
    );
  }

  return (
    <Layout>
      <ErrorBoundary>
        <StepsIndicator
          step={currentStep}
          stepText={
            languages && languages.stepTitle1
              ? languages.stepTitle1
              : "Membership"
          }
          subTitleHeader={
            languages && languages.stepSubtitle1
              ? languages.stepSubtitle1
              : "Select your membership type"
          }
          languages={languages}
        />
        <div className="flex justify-center flex-col">
          <div className="card-wrapper">
            <Product
              languages={languages}
              locationData={locationData}
              isProductLoaded={isProductLoaded}
              error={error}
              products={products}
              selectMembership={selectMembership}
              locationDataCurrency={locationDataCurrency}
              couponObj={couponObj}
              isUserLogged={isUserLogged}
              businessCategories={businessCategories}
              benefitsTranslations={benefitsTranslations}
            />
          </div>
          <NextButton
            isProcessing={isProcessing}
            goNextStep={goNextStep}
            languages={languages}
            isDisabled={isDisabled}
            full={full}
            part={part}
          />
        </div>
      </ErrorBoundary>
    </Layout>
  );
}
